import { Text } from "@chakra-ui/layout";
import { useBreakpointValue } from "@chakra-ui/media-query";
import PropTypes from "prop-types";
import styles from "./Heading.styles";

export const Heading = ({ children, size = 0, ...props }) => {
  const breakpointSize = useBreakpointValue(size);
  const _size = typeof size === "object" ? breakpointSize : size;
  return (
    <Text {...styles["h" + _size]} {...props}>
      {children}
    </Text>
  );
};

Heading.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.oneOf(["1", "2", "3", "4", "5", "6"]),
    PropTypes.object,
  ]).isRequired,
  children: PropTypes.node,
};
